import { createTheme } from '@mui/material/styles';
import { colors, typography } from './theme';

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
      light: colors.primaryLight,
      dark: colors.primaryDark,
    },
    secondary: {
      main: colors.primary,
    },
    background: {
      default: colors.background,
      paper: colors.backgroundSecondary,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
  },
  typography: {
    fontFamily: typography.fontFamily.primary,
    h1: {
      fontFamily: typography.fontFamily.heading,
      fontWeight: typography.fontWeight.bold,
      fontSize: typography.fontSize.xxxl,
    },
    h2: {
      fontFamily: typography.fontFamily.heading,
      fontWeight: typography.fontWeight.bold,
      fontSize: typography.fontSize.xxl,
    },
    h3: {
      fontFamily: typography.fontFamily.heading,
      fontWeight: typography.fontWeight.bold,
      fontSize: typography.fontSize.xl,
    },
    body1: {
      fontFamily: typography.fontFamily.primary,
      fontSize: typography.fontSize.md,
      fontWeight: typography.fontWeight.regular,
    },
    body2: {
      fontFamily: typography.fontFamily.primary,
      fontSize: typography.fontSize.sm,
      fontWeight: typography.fontWeight.regular,
    },
    button: {
      fontFamily: typography.fontFamily.primary,
      fontWeight: typography.fontWeight.medium,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          padding: '8px 16px',
          fontWeight: typography.fontWeight.medium,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 122, 255, 0.3)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
          fontFamily: typography.fontFamily.primary,
          fontWeight: typography.fontWeight.medium,
        },
        filled: {
          backgroundColor: colors.primary,
          color: colors.textInverse,
          '&:hover': {
            backgroundColor: colors.primaryDark,
          },
        },
        outlined: {
          borderColor: colors.border,
          color: colors.textPrimary,
          '&:hover': {
            borderColor: colors.primary,
            backgroundColor: 'rgba(0, 122, 255, 0.08)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            '& fieldset': {
              borderColor: colors.borderLight,
            },
            '&:hover fieldset': {
              borderColor: colors.primary,
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.primary,
            },
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.backgroundSecondary,
          borderRadius: '16px 16px 0 0',
        },
      },
    },
  },
});
